import Cross from './Cross.vue';

export default Cross;
